var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('course-list',{attrs:{"course-type":_vm.courseType,"name":_vm.courseName}}),_c('recommend-course',{staticStyle:{"margin-top":"80px"},attrs:{"course-type":"C"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }